import styled from "@emotion/styled"
import { AppBar, Container, IconButton, Typography } from "@mui/material"
import CustomButton from "../custom-button/custom-button.component"
import CustomLink from "../custom-link/custom-link.component"

export const Header = styled(AppBar)`
  background-color: ${({ theme }) => theme.palette.text.light};
  color: ${({ theme }) => theme.palette.primary.dark};
  padding: 1rem 0;
  transition: all 0.3s ease;
  ${({ theme }) => theme.breakpoints.up("lg")} {
    padding: 1.25rem 0;
  }
  &.transparent {
    background-color: transparent;
  }
  &.white {
    color: ${({ theme }) => theme.palette.text.light};
    .arrow {
      path {
        fill: ${({ theme }) => theme.palette.text.light};
      }
    }
    .menu {
      path {
        fill: ${({ theme }) => theme.palette.text.light};
      }
    }
  }

  &.MuiPaper-elevation4 {
    color: ${({ theme }) => theme.palette.primary.dark};
    background-color: ${({ theme }) => theme.palette.text.light};
    .arrow {
      path {
        fill: ${({ theme }) => theme.palette.primary.dark};
      }
    }
    .menu {
      path {
        fill: rgb(1, 18, 40);
      }
    }
  }
  &.open {
    background-color: ${({ theme }) => theme.palette.tertiary.light};
    padding: 1.5rem 0;
  }
`

export const Wrapper = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const LogoWrapper = styled(CustomLink)`
  display: flex;
  svg {
    width: 91px;
    height: auto;
    ${({ theme }) => theme.breakpoints.up("lg")} {
      width: 116px;
    }
  }
`

export const LinksWrapper = styled.div`
  display: none;
  ${({ theme }) => theme.breakpoints.up("lg")} {
    display: flex;
    gap: 3rem;
  }
`

export const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 1rem 0;
  position: relative;
  cursor: pointer;
  svg {
    transition: all 0.3s ease;
  }
  :hover {
    z-index: 2;
    svg {
      color: ${({ theme }) => theme.palette.primary.main} !important;
      transform: rotate(180deg);
      z-index: 3;
    }
    .subitems {
      opacity: 1;
      pointer-events: all;
      top: 0;
    }
    .hasSub {
      color: ${({ theme }) => theme.palette.text.primary};
    }
  }
`

export const Link = styled(CustomLink)`
  color: inherit;
  font-size: ${({ theme }) => theme.typography.pxToRem("17")};
  font-weight: 600;
  line-height: normal;
`

export const StyledText = styled(Typography)`
  color: inherit;
  font-size: ${({ theme }) => theme.typography.pxToRem("17")};
  font-weight: 600;
  line-height: normal;
  &.parent {
    z-index: 3;
  }
`

export const StyledBtn = styled(CustomButton)`
  display: none;
  ${({ theme }) => theme.breakpoints.up("md")} {
    display: block;
  }
`

export const MenuBtn = styled(IconButton)`
  ${({ theme }) => theme.breakpoints.up("lg")} {
    display: none;
  }
`

export const SubItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
  top: 30px;
  width: 250px;
  left: -2rem;
  box-shadow: 0 calc(0.69444 * 1vw) calc(1.38889 * 1vw) rgba(89, 102, 132, 0.12);
  border-radius: 14px;
  overflow: hidden;
  padding-top: 4rem;
  padding-bottom: 1rem;
  background-color: ${({ theme }) => theme.palette.secondary.light};
`

export const SubLink = styled(CustomLink)`
  padding: 0.5rem 2rem;
  font-size: 1rem;
  color: ${({ theme }) => theme.palette.text.content};
  transition: all 0.3s ease;
  font-weight: 600;
  :hover {
    padding-left: 2.3125rem;
  }
`

export const ButtonsWrapper = styled.div`
  gap: 0.5rem;
  display: none;
  ${({ theme }) => theme.breakpoints.up("lg")} {
    display: flex;
    align-items: center;
    margin-left: 2.5rem;
  }
`
